export default "__VITE_ASSET__1erNqWTw__"